class ModelComponentStore {
  constructor() {
    this.__components = {};
  }

  componentForModel(model) {
    return this.__components[model.id];
  }

  addComponent(model, component) {
    this.__components[model.id] = component;
  }
}

const singleton = new ModelComponentStore();

export default singleton;
